import { useParams } from 'react-router-dom';
import { Skeleton } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { channelApi } from '@/api/channel.api';
import { ChannelType } from '@/proto/agentplatform/v1/channel_pb';
import ChannelAccountDetail from './ChannelAccountDetail';
import WebSocketAccountDetail from './WebSocketDetailComponents/WebSocketAccountDetail';

/** 渠道账号详情分流：WebSocket 走新详情页，飞书/QQ 走原有详情页。
 *  拿到 account.type 后决定渲染哪套；React Query 缓存下与子页共享请求。 */
export default function ChannelAccountDetailRouter() {
  const { accountId } = useParams<{ accountId: string }>();

  const { data: account, isLoading } = useQuery({
    queryKey: ['channel_account', accountId] as const,
    queryFn: () => channelApi.getChannelAccount(accountId!),
    enabled: !!accountId,
  });

  if (isLoading) {
    return (
      <div className="pp-page">
        <Skeleton active paragraph={{ rows: 6 }} />
      </div>
    );
  }

  if (account && account.type === ChannelType.BRIDGE) {
    return <WebSocketAccountDetail account={account} />;
  }

  // 飞书 / QQ（及加载失败兜底）：原有详情页自行处理。
  return <ChannelAccountDetail />;
}
